module.exports = __webpack_public_path__ + "img/p6.57232101.png";